export enum PageNames {
  OVERVIEW = 'overview',
  COLLABORATION = 'collaboration',
  DOCUMENTS = 'documents'
}
